exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "form.captionForm-96f078ad{width:calc(100% - 3.5em)}form.captionForm-96f078ad select{display:inline-block;width:auto;font-size:14px;line-height:1;margin-right:2px;margin-bottom:0;height:32px}form.captionForm-96f078ad:after{content:'';display:table-cell;clear:both}form.captionForm-96f078ad select{padding:0}.DayPicker-wrapper:focus{outline:none}\n", ""]);

// Exports
exports.locals = {
	"captionForm": "captionForm-96f078ad"
};